const sponsorshipCodeKeys = {
    all: () => [{ entity: 'sponsorshipCode' }],
};

export default sponsorshipCodeKeys;
